var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  height: 7,
  viewBox: "0 0 12 7",
  width: 12,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m1 1 4.60667 4.83333c.0516.05174.11291.09279.1804.12079.0675.02801.13986.04243.21293.04243.07308 0 .14543-.01442.21293-.04243.06749-.028.1288-.06905.1804-.12079l4.60667-4.83333",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.6
})));
export default SvgChevronDown;